import React from 'react';
import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import type { OrderSettlementCommandState } from '../../../dto/orderSettlement';

interface Props {
  state: OrderSettlementCommandState | null | undefined;
}

/** A deliberately coarse command result suitable for every permitted role. */
export const OrderSettlementCommandStatus: React.FC<Props> = ({ state }) => {
  const { t } = useTranslation('orders');

  if (state === 'ADMIN_REQUIRED') {
    return (
      <Tag color="warning" style={{ borderRadius: 999, paddingInline: 10, fontWeight: 600 }}>
        {t('orderDetail.settlementCommandAdminRequired')}
      </Tag>
    );
  }

  if (state === 'APPLIED') {
    return (
      <Tag color="success" style={{ borderRadius: 999, paddingInline: 10, fontWeight: 600 }}>
        {t('orderDetail.settlementCommandApplied')}
      </Tag>
    );
  }

  if (state === 'SUPERSEDED') {
    return (
      <Tag color="default" style={{ borderRadius: 999, paddingInline: 10, fontWeight: 600 }}>
        {t('orderDetail.settlementCommandSuperseded')}
      </Tag>
    );
  }

  return null;
};
